import { useState } from "react";

import { useDeleteOrderAndRelated } from "~/providers/hooks/queries/useDeleteOrderAndRelated";
import { useDeleteSchedule } from "~/providers/hooks/queries/useDeleteSchedule";
import { AddOrderModal } from "~/providers/modals/AddOrderModal";
import { Order } from "~/providers/utils/types/interactions";
import { OrderDetailsDrawer, OrdersLayout } from "./orderPanelComponents/index";
import { OrdersList } from "./orderPanelComponents/OrdersList";

interface OrderPanelProps {
  patientId: string;
}

export const OrderPanel = ({ patientId }: OrderPanelProps) => {
  const [addOrderModal, setAddOrderModal] = useState(false);
  const [showDeleteOrderModal, setShowDeleteOrderModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<Order>();

  const toggleDeleteOrderModal = () => setShowDeleteOrderModal((prev) => !prev);
  const handleCloseDrawer = () => setSelectedOrder(undefined);

  const handleCloseAll = () => {
    toggleDeleteOrderModal();
    handleCloseDrawer();
  };

  const {
    deleteOrderAndRelatedMutation,
    isPending: loadingDeleteOrderAndRelated,
  } = useDeleteOrderAndRelated({
    patientId,
    orderId: selectedOrder?.id,
    onSuccess: handleCloseAll,
  });

  const { deleteScheduleMutation, isPending: loadingDeleteSchedule } =
    useDeleteSchedule({
      patientId,
      scheduleId: selectedOrder?.id,
      onSuccess: handleCloseAll,
    });

  const handleDelete = () => {
    if (selectedOrder?.type === "schedule") {
      deleteScheduleMutation();
    } else {
      deleteOrderAndRelatedMutation();
    }
  };

  const loadingDelete = loadingDeleteOrderAndRelated || loadingDeleteSchedule;

  return (
    <OrdersLayout handleAddOrder={() => setAddOrderModal(true)}>
      <OrdersList
        patientId={patientId}
        handleViewOrder={(order) => setSelectedOrder(order)}
      />
      <OrderDetailsDrawer
        order={selectedOrder}
        handleClose={handleCloseDrawer}
        handleDelete={handleDelete}
        loadingDelete={loadingDelete}
        showDeleteOrderModal={showDeleteOrderModal}
        toggleDeleteOrderModal={toggleDeleteOrderModal}
        allowDeleteOrder
      />
      <AddOrderModal
        patientId={patientId}
        show={addOrderModal}
        onClose={() => setAddOrderModal(false)}
      />
    </OrdersLayout>
  );
};
